import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Observable, Subscribable } from 'knockout';
import { withEffect } from 'mixins/withEffect';
import { EffectsContainer } from 'mixins/withEffects';
import HeatmapViewType from '../enums/viewType';
import HeatmapVM from '../heatmap';
import HeatmapViewLink from './viewLink';
import './viewsPanel.html';
import './viewsPanel.scss';

export interface HeatmapViewsPanelConfig {
    heatmap: HeatmapVM
    view: Observable<HeatmapViewType>
}

@injectable()
export default class HeatmapViewsPanelVM {
    private heatmap: HeatmapVM

    viewLinks: Subscribable<Array<HeatmapViewLink>>

    constructor(
        @inject(wccModules.componentConfig) config: HeatmapViewsPanelConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        this.heatmap = config.heatmap;

        this.viewLinks = ko.pureComputed(() => this.getViewLinks());

        const activeViewLink = this.viewLinks.find(link => link.isActive());

        effects.register(() => {
            this.activateView(config.view());

            return withEffect(viewLink => {
                if (viewLink != undefined)
                    config.view(viewLink.type());
            }, [activeViewLink]);
        });

        ko.applyBindingsToNode(info.element, {
            'visible': this.viewLinks.is(links => links.length > 1),

            'css': {
                'wcc-heatmap__views-panel': true
            }
        });
    }

    activateView = (viewLinkOrType: HeatmapViewLink | HeatmapViewType) => {
        if (viewLinkOrType instanceof HeatmapViewLink)
            this.viewLinks().forEach(link => link.isActive(link === viewLinkOrType));
        else
            this.activateView(this.viewLinks().find(link => link.type() === viewLinkOrType) ?? this.viewLinks()[0]);
    }

    private getViewLinks() {
        const viewLinks = new Array<HeatmapViewLink>();

        viewLinks.push(new HeatmapViewLink({ title: labels.PinnedComments, type: HeatmapViewType.pinnedComments, isActive: true }));

        if (this.heatmap.allowHeatmapView())
            viewLinks.push(new HeatmapViewLink({ title: labels.Heatmap, type: HeatmapViewType.heatmap }));

        return viewLinks;
    }
}